import _createForOfIteratorHelper from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import FooterToolBar from '@/components/tool/FooterToolBar.vue';
import { getPagesettingData, updatePagesetting, updateCatalogsetting, updateContactsetting, deleteContactUs, addContactUsEmail, updateSellerEmail } from '@/services/systemsetting';
// import {upload} from '@/services/common.js';
import TinymceEditor from '@/components/tinymce';
export default {
  components: {
    TinymceEditor: TinymceEditor,
    FooterToolBar: FooterToolBar
  },
  i18n: require('./i18n-pagesetting.js'),
  props: ['pagesetting'],
  data: function data() {
    return {
      defaultLangObj: {},
      languageList: [],
      loadingSave: false,
      tabKey: 0,
      dataForm: {
        dataList: [{
          langId: '',
          languageName: "",
          pageContent: ''
        }]
      },
      descContentList: [],
      contentTitle: '',
      contentVisible: false,
      contentData: [
        // {
        // 	url:'1111111',
        // 	lineList: [
        // 		{
        // 		langId: 3,
        //         content: "2322432"
        // 		}
        // 	]
        // },
        // {
        // 	url:'11122221111',
        // 	lineList: [
        // 		{
        // 		langId: 3,
        //         content: "2asdasd阿斯蒂芬2432"
        // 		},
        // 		{
        // 		langId: 2,
        //         content: "中午跟"
        // 		},
        // 		{
        // 		langId: 4,
        //         content: "英文"
        // 		}
        // 	]
        // }
      ],
      specValueData: {
        url: '',
        lineList: []
      },
      initialNameList: [],
      loadingAdd: false,
      loadingEdit: false,
      loadingTable: false,
      editId: undefined,
      targetVisible: false,
      loadingConadd: false,
      logVisible: false,
      logData: {
        catalogPdfUrl: '',
        catalogPageUrl: ''
      },
      contactData: {
        targetEmail: ''
      },
      replyEmailData: {
        replyEmail: ''
      },
      oldReplyEmailData: {},
      // 原始replay email
      loadingLogadd: false,
      descContentList3: [],
      descContentList2: [],
      oldObj: {},
      contactDataList: [],
      oldContactDataList: [],
      contactTitle: '',
      editIndex: '',
      replyVisible: false,
      // 编辑回复邮箱弹窗 visible
      loadingReplayEmail: false,
      // 编辑回复邮箱 loading
      sellerEmail: '',
      sellerEmailVisible: false,
      sellerEmailData: {
        sellerEmail: ''
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    self.getPageSetting();
  },
  methods: {
    editReplyEmail: function editReplyEmail() {
      this.resetReplyEmailvalue();
      this.replyVisible = true;
    },
    editSellerEmail: function editSellerEmail() {
      this.sellerEmailData.sellerEmail = this.sellerEmail;
      this.sellerEmailVisible = true;
    },
    editSellerEmailData: function editSellerEmailData() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this.loadingConadd = true;
              _context.n = 1;
              return updateSellerEmail(_this.sellerEmailData.sellerEmail);
            case 1:
              res = _context.v;
              if (res.data.code == 200) {
                _this.$message.success(_this.$t('pagesetting.editsuccess'));
                _this.sellerEmailVisible = false;
                _this.getPageSetting();
                _this.loadingConadd = false;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    tabChange: function tabChange(activeKey) {
      //tabs 切换事件
      this.tabKey = activeKey;
    },
    // imgUpload(blobInfo, success, failure){
    // 	console.log(111)
    // 	let formData = new FormData();
    // 	console.log(blobInfo)
    // 	formData.append('type',6)
    // 	formData.append('file', blobInfo.blob(), blobInfo.filename());
    // 	upload(formData).then((res)=>{
    // 		if(res.data.code == 200){
    // 			success(res.data.data.urlpath+res.data.data.uploadfilepath);
    // 		}else{
    // 			failure('HTTP Error: ' + res.message);
    // 		}
    // })
    // },
    initData: function initData() {
      var self = this;
      self.descContentList = [];
      self.initialNameList = [];
      self.defaultLangObj = JSON.parse(localStorage.getItem('defaultLangObj'));
      self.langList = JSON.parse(localStorage.getItem('langList'));
      var _iterator = _createForOfIteratorHelper(self.langList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var nameObj = {};
          //标题
          nameObj.titleName = this.$t('pagesetting.desccontent') + '(' + item.langName + ')';
          //多语言id
          nameObj.langId = item.langId;
          //名称
          nameObj.content = '';
          if (item.langId == self.defaultLangObj.langId) {
            nameObj.required = true;
          } else {
            nameObj.required = false;
          }
          self.initialNameList.push(nameObj);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var _iterator2 = _createForOfIteratorHelper(self.contentData),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _item = _step2.value;
          var showObj = _item.lineList.filter(function (item2) {
            return item2.langId == self.defaultLangObj.langId;
          });
          self.descContentList.push(showObj[0]);
          console.log(showObj[0], 'showobj');
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      console.log(self.descContentList, 'showobj222222222');
      self.specValueData.lineList = _.cloneDeep(self.initialNameList);
      console.log(self.specValueData, 'baledata...');
    },
    getPageSetting: function getPageSetting() {
      var _this2 = this;
      var self = this;
      self.loadingTable = true;
      getPagesettingData().then(function (res) {
        if (res.data.code == 200) {
          var _res$data$data$contac, _res$data$data$contac2;
          self.contentData = res.data.data.list;
          _this2.logData = res.data.data.catalogUrl ? res.data.data.catalogUrl : _this2.logData;
          _this2.oldObj = _.cloneDeep(res.data.data.catalogUrl ? res.data.data.catalogUrl : _this2.logData);
          _this2.contactDataList = (_res$data$data$contac = res.data.data.contactUsEmails) !== null && _res$data$data$contac !== void 0 && _res$data$data$contac.sendEmail ? res.data.data.contactUsEmails.sendEmail : _this2.contactDataList;
          _this2.oldContactDataList = _.cloneDeep((_res$data$data$contac2 = res.data.data.contactUsEmails) !== null && _res$data$data$contac2 !== void 0 && _res$data$data$contac2.sendEmail ? res.data.data.contactUsEmails.sendEmail : _this2.contactDataList);
          _this2.replyEmailData = res.data.data.contactUsEmails ? res.data.data.contactUsEmails : _this2.replyEmailData;
          _this2.oldReplyEmailData = _.cloneDeep(res.data.data.contactUsEmails ? res.data.data.contactUsEmails : _this2.replyEmailData);
          _this2.sellerEmail = res.data.data.sellerEmail;
          _this2.initData();
        }
      }).finally(function () {
        _this2.loadingTable = false;
      });
    },
    //初始规格值化弹窗
    resetspecValueData: function resetspecValueData() {
      this.specValueData = {
        url: '',
        lineList: _.cloneDeep(this.initialNameList)
      };
    },
    /* 取消按钮 */resetFormDate: function resetFormDate() {
      this.contentVisible = false;
      this.resetspecValueData();
    },
    /* 添加按钮 */addSpecValueModal: function addSpecValueModal() {
      this.contentTitle = this.$t('pagesetting.addContent');
      this.resetspecValueData();
      this.contentVisible = true;
    },
    addSpecValue: function addSpecValue() {
      var _this3 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var newData = _.cloneDeep(_this3.specValueData);
          newData.lineList = newData.lineList.map(function (item) {
            return {
              content: item.content,
              langId: item.langId
            };
          });
          _this3.contentData.push(newData);
          _this3.loadingAdd = true;
          updatePagesetting({
            list: _this3.contentData
          }).then(function (res) {
            if (res.data.code == 200) {
              _this3.$message.success(_this3.$t('pagesetting.addsuccess'));
              _this3.contentVisible = false;
              _this3.getPageSetting();
            }
          }).finally(function () {
            _this3.loadingAdd = false;
          });
        }
      });
    },
    /* 规格值编辑按钮 */editSpecValueBtn: function editSpecValueBtn(index) {
      var _this4 = this;
      this.editId = index;
      console.log(this.contentData[index], '1111111111111');
      this.contentTitle = this.$t('pagesetting.editContent');
      this.contentVisible = true;
      var newNameList = _.cloneDeep(this.initialNameList);
      console.log(newNameList, '222222222222222222222');
      var _iterator3 = _createForOfIteratorHelper(newNameList),
        _step3;
      try {
        var _loop = function _loop() {
          var initial = _step3.value;
          var findObj = _.find(_this4.contentData[index].lineList, function (o) {
            return o.langId == initial.langId;
          });
          if (findObj) {
            initial.langId = findObj.langId;
            initial.content = findObj.content;
          }
        };
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      this.specValueData.lineList = _.cloneDeep(newNameList);
      this.specValueData.url = this.contentData[index].url;
    },
    updateSpecValue: function updateSpecValue() {
      var _this5 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var self = _this5;
          var newData = _.cloneDeep(_this5.specValueData);
          newData.lineList = newData.lineList.map(function (item) {
            return {
              content: item.content,
              langId: item.langId
            };
          });
          _this5.contentData[_this5.editId] = newData;
          self.loadingEdit = true;
          updatePagesetting({
            list: _this5.contentData
          }).then(function (res) {
            if (res.data.code == 200) {
              self.$message.success(_this5.$t('pagesetting.editsuccess'));
              self.contentVisible = false;
              self.getPageSetting();
            }
          }).finally(function () {
            self.loadingEdit = false;
          });
        }
      });
    },
    // 删除规格值
    deleteSpecValue: function deleteSpecValue(index) {
      var _this6 = this;
      var self = this;
      self.loadingTable = true;
      this.contentData.splice(index, 1);
      updatePagesetting({
        list: this.contentData
      }).then(function (res) {
        if (res.data.code == 200) {
          self.$message.success(_this6.$t('pagesetting.deletesuccess'));
          self.getPageSetting();
        }
      });
    },
    // 新增/编辑联系我们
    addEditcontact: function addEditcontact() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _this7.loadingConadd = true;
              if (!(_this7.contactTitle == 'add')) {
                _context2.n = 2;
                break;
              }
              _context2.n = 1;
              return addContactUsEmail(_this7.contactData.targetEmail);
            case 1:
              res = _context2.v;
              try {
                if (res.data.code == 200) {
                  _this7.$message.success(_this7.$t('pagesetting.addsuccess'));
                  _this7.targetVisible = false;
                  _this7.getPageSetting();
                }
              } finally {
                _this7.loadingConadd = false;
              }
              _context2.n = 4;
              break;
            case 2:
              if (!(_this7.contactTitle == 'edit')) {
                _context2.n = 4;
                break;
              }
              _context2.n = 3;
              return updateContactsetting(_this7.oldContactDataList[_this7.editIndex], _this7.contactData.targetEmail, 2);
            case 3:
              _res = _context2.v;
              // type 2 是发送邮箱
              try {
                if (_res.data.code == 200) {
                  _this7.$message.success(_this7.$t('pagesetting.editsuccess'));
                  _this7.targetVisible = false;
                  _this7.getPageSetting();
                }
              } finally {
                _this7.loadingConadd = false;
              }
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    addTarget: function addTarget() {
      this.contactTitle = 'add';
      this.resetContact();
      this.targetVisible = true;
    },
    editTarget: function editTarget(index) {
      this.editIndex = index;
      this.contactTitle = 'edit';
      this.contactData.targetEmail = this.oldContactDataList[index];
      this.targetVisible = true;
    },
    // 删除联系我们
    deleteTarget: function deleteTarget(index) {
      var _this8 = this;
      var self = this;
      self.loadingTable = true;
      deleteContactUs(this.oldContactDataList[index]).then(function (res) {
        if (res.data.code == 200) {
          self.$message.success(_this8.$t('pagesetting.deletesuccess'));
          self.getPageSetting();
        }
      });
    },
    // 联系我们取消
    resetContact: function resetContact() {
      this.resetContactvalue();
      this.targetVisible = false;
    },
    resetContactvalue: function resetContactvalue() {
      this.contactData = {
        targetEmail: ''
      };
    },
    // catalog取消
    resetLog: function resetLog() {
      this.resetLogvalue();
      this.logVisible = false;
    },
    resetLogvalue: function resetLogvalue() {
      this.logData = {
        catalogPdfUrl: this.oldObj.catalogPdfUrl,
        catalogPageUrl: this.oldObj.catalogPageUrl
      };
    },
    // 取消编辑回复邮箱
    resetReplyEmail: function resetReplyEmail() {
      this.resetReplyEmailvalue();
      this.replyVisible = false;
    },
    resetReplyEmailvalue: function resetReplyEmailvalue() {
      this.replyEmailData = {
        replyEmail: this.oldReplyEmailData.replyEmail
      };
    },
    // 新增编辑回复邮箱
    addEditReplyEmail: function addEditReplyEmail() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (_this9.replyEmailData.replyEmail) {
                _context3.n = 1;
                break;
              }
              _this9.$message.warn(_this9.$t('pagesetting.replayTip'));
              return _context3.a(2);
            case 1:
              _this9.loadingReplayEmail = true;
              _context3.n = 2;
              return updateContactsetting(_this9.oldReplyEmailData.replyEmail || '', _this9.replyEmailData.replyEmail || '', 1);
            case 2:
              res = _context3.v;
              // type 1 是回复邮箱
              try {
                if (res.data.code == 200) {
                  _this9.$message.success(_this9.$t('pagesetting.editsuccess'));
                  _this9.replyVisible = false;
                  _this9.getPageSetting();
                }
              } finally {
                _this9.loadingReplayEmail = false;
              }
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    // 新增编辑catalog
    addEditlog: function addEditlog() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this0.loadingLogadd = true;
              _context4.n = 1;
              return updateCatalogsetting(_this0.logData);
            case 1:
              res = _context4.v;
              try {
                if (res.data.code == 200) {
                  _this0.$message.success(_this0.$t('pagesetting.editsuccess'));
                  _this0.logVisible = false;
                  _this0.getPageSetting();
                }
              } finally {
                _this0.loadingLogadd = false;
              }
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    editLog: function editLog() {
      this.resetLogvalue();
      this.logVisible = true;
    },
    deleteLog: function deleteLog() {}
    /* 保存 */
    // save() {
    // 	let self = this;
    // 	self.loadingSave = true;
    // 	updatePagesetting(self.dataForm.dataList).then(result => {
    // 		if (result.data.code == 200) {
    // 			this.$message.success(this.$t('public.saveSuccessfully'));
    // 		}
    // 		self.loadingSave = false; 
    // 	});
    // }
  }
};